import { render, staticRenderFns } from "./PublicManifest.vue?vue&type=template&id=00829523&"
import script from "./PublicManifest.vue?vue&type=script&lang=js&"
export * from "./PublicManifest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports